export const glossaryApiKey = {
  createdLikedGlossary: "create liked glossary",
  removeLikedGlossary: "delete liked glossary",
};
